<template>
  <div class="c-tab-data">
    <div class="c-control-btn">
      <Button icon="md-download" @click="downData" :loading="loading">数据导出</Button>
      <Button @click="modalColumn = true" :loading="loading">自定义列</Button>
    </div>
    <div class="tab-include__wrapper">
      <Viewport v-model="height">
        <el-table
          class="common-el-table-styles summary-el-table-styles"
          ref="table"
          v-loading="loading"
          :data="tableData"
          :height="height - 6"
          :summary-method="summaries"
          show-summary
          border
          stripe
        >
          <template slot="empty">
            <no-data />
          </template>
          <el-table-column
            v-for="(col, id) in tableCol"
            :key="id + col.key"
            :prop="col.key"
            :label="col.title"
            :fixed="col.fixed"
            :show-overflow-tooltip="col.overflow"
            :min-width="col.width"
            :align="col.align"
          >
            <template slot-scope="scope">
              <span>{{ scope.row[col.key] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </Viewport>
    </div>
    <!-- 自定义列 -->
    <custom-column v-model="modalColumn" :data="columns" :subTitle="['基础数据']" @on-select="selectColumn" />
  </div>
</template>
<script>
import mixinTable from '../../mixin_table'
import columns from '../../../data/include_columns'
import { isArray, isEmpty, throttle, timeout } from '@/common/js/utils'
import { toThousands, toPercentFixed } from '@/common/js/filters'
import { getPlanDataEvaluate } from '@/api/ptom.data.model'
import { HOST_API } from '@/api/config'
import CustomColumn from '@/components/converter/custom-column.vue'

export default {
  name: 'TabInclude',
  mixins: [mixinTable],
  components: { CustomColumn },
  props: {
    detailTime: {
      type: Array,
      required: true
    },
    productId: {
      type: Number
    },
    chlUserId: {
      type: Number
    },
    sourceId: {
      type: Number
    },
    planName: {
      type: String
    }
  },
  computed: {
    tableCol() {
      return this.columns.filter((ret) => !ret.show)
    }
  },
  methods: {
    downData() {
      const [begin, end] = this.detailTime
      const url = `${HOST_API}/api/ptom/planDataDetail/downplandataevaluate?`

      const querystring = new URLSearchParams()
      querystring.append('sessionid', this.$store.state.token)
      querystring.append('planName', this.planName)
      querystring.append('gameId', this.productId)
      querystring.append('chlId', this.chlUserId)
      querystring.append('sourceId', this.sourceId)
      querystring.append('beginTime', begin)
      querystring.append('endTime', end)
      window.open(url.concat(querystring.toString()))
    },
    getData() {
      const [beginTime, endTime] = this.detailTime
      const params = { gameId: this.productId, chlId: this.chlUserId, sourceId: this.sourceId, beginTime, endTime }
      this.loading = true
      getPlanDataEvaluate(params)
        .then((data) => {
          if (typeof data !== 'symbol') {
            this.loading = false
            if (!data) return
            const { list, sum_data } = data
            if (isArray(list) && sum_data) {
              this.initTableColumns()
              this.tableData = list
              this.sumdata = sum_data
            } else {
              this.columns = []
              this.tableData = []
            }
          }
        })
        .catch(() => {
          this.loading = false
          this.tableData = []
          this.columns = []
        })
    },
    initTableColumns() {
      const shows = this.getCustomStorage('detailIncludeCustomColumn') // 同步本地存储自定义列
      if (shows.length) {
        const local_shows = shows
          .filter((ret) => ret)
          .map((ret) => {
            const item = columns.filter((met) => met.key === ret).pop() || {}
            item.show = false
            return item
          })
        const extend_shows = columns
          .filter((ret) => !shows.includes(ret.key))
          .map((ret) => {
            ret.show = true
            return ret
          })
        this.columns = [...local_shows, ...extend_shows]
      } else this.columns = [...columns]
    },
    summaries(param) {
      const { columns } = param
      const data = JSON.parse(JSON.stringify(this.sumdata))
      const sums = []
      columns.forEach((column, index) => {
        const prop = column.property
        const val = prop && parseFloat(data[prop])
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const twoDecimal = ['createRoleCost', 'throusandProfitPvCost', 'newPayCost', 'amount', 'newRolePayCntCost']
        if (isEmpty(val)) sums[index] = ''
        else if (twoDecimal.includes(prop)) sums[index] = toThousands(val)
        else if (prop.indexOf('Rate') > -1) sums[index] = toPercentFixed(val)
        else sums[index] = val
      })
      return sums
    }
  },
  watch: {
    detailTime() {
      throttle(() => {
        this.pageIndex = 1
        this.getData()
      }, 300)()
    },
    columns: {
      handler(nVal) {
        const show = nVal.filter((ret) => !ret.show).map((met) => met.key)
        this.setCustomStorage('detailIncludeCustomColumn', show)
        this.$nextTick(() => {
          this.$refs.table && this.$refs.table.doLayout()
        })
      },
      deep: true
    }
  },
  data() {
    return {
      height: 0,
      modalColumn: null,
      tableData: [],
      columns: [],
      sumdata: null
    }
  },
  created() {
    this.getData()
  }
}
</script>
<style lang="scss" scoped>
.c-tab-data {
  height: 100%;

  .c-control-btn {
    padding: 5px 0px;
    text-align: right;
  }

  .tab-include__wrapper {
    height: 100%;
  }
}
</style>
